import React, { useCallback } from 'react'
import block from 'bem-cn'

import useLoading from './model/useLoading'

import './LoadableImage.scss'

interface ILoadableImageProps {
  src: string
  alt?: string
  onLoad?: () => void
  onError?: () => void
  className?: string
  classNameContainer?: string
  hidden?: boolean
  animationType?: 'smallToBig' | 'slide' | 'appearance' | 'default'
  isSlotImage?: boolean
}

const b = block('loadable-image')

const LoadableImage: React.FC<ILoadableImageProps> = props => {
  const {
    src,
    alt = '',
    onLoad = () => {},
    onError = () => {},
    className = '',
    hidden = false,
    classNameContainer = '',
    animationType = 'appearance',
    isSlotImage,
  } = props

  const { currentSrc, isLoaded, imageRef, containerRef, isVisible, setIsLoaded } = useLoading({ src, onLoad })

  const _onError = useCallback(() => {
    setIsLoaded(true)
    onError()
  }, [onError, setIsLoaded])

  return (
    <div
      ref={containerRef}
      className={b('container', {
        loaded: isLoaded,
        forwardAnimationType: isLoaded ? animationType : null,
        backwardAnimationType: !isLoaded ? animationType : null,
      }).mix(classNameContainer)}>
      {!isLoaded && <div className={b('slot-plug')} />}
      <img
        onError={_onError}
        ref={imageRef as React.LegacyRef<HTMLImageElement>}
        className={[
          b('image', {
            loaded: isLoaded,
            isVisible,
            hidden,
          }),
          className,
        ].join(' ')}
        src={currentSrc}
        alt={alt}
      />
    </div>
  )
}

export default LoadableImage
